import React, { useRef } from "react";

import "../Asociados/asociadosTable.css";

import SkeletonTable from "../Skeleton/SkeletonTable";
import { handleStatus } from "../../helperFunctions/helpers";
import { Singleton } from "helper/tools";
import { format } from "date-fns";

/**
 *
 * @param {*} param0
 * @returns
 */

export default function PedidosEspecialesTable({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <>
      <table
        className="table table-borderless datable sortable table-hover"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              scope="col"
              data-column="id"
              style={{ width: "90px" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>
            <th
              scope="col"
              data-column="proveedor.nombre"
              onClick={(event) => handleSort(event)}
            >
              Proveedor
            </th>
            <th
              scope="col"
              data-column="cantidad"
              style={{ width: "90px" }}
              onClick={(event) => handleSort(event)}
            >
              Cantidad
            </th>
            <th
              scope="col"
              data-column="nombre"
              onClick={(event) => handleSort(event)}
            >
              Nombre
            </th>
            <th
              scope="col"
              data-column="marca.id"
              onClick={(event) => handleSort(event)}
            >
              Marca
            </th>

            <th
              scope="col"
              data-column="genero.id"
              onClick={(event) => handleSort(event)}
            >
              Genero
            </th>

            <th
              scope="col"
              data-column="costo"
              onClick={(event) => handleSort(event)}
            >
              Costo
            </th>

            <th
              scope="col"
              data-column="totalPrecioCosto"
              onClick={(event) => handleSort(event)}
            >
              Total Precio Costo
            </th>

            <th
              scope="col"
              data-column="margen"
              onClick={(event) => handleSort(event)}
            >
              Margen
            </th>

            <th
              scope="col"
              data-column="precioPublico"
              onClick={(event) => handleSort(event)}
            >
              Precio Publico
            </th>

            <th
              scope="col"
              data-column="totalPrecioPublico"
              onClick={(event) => handleSort(event)}
            >
              Total Precio Publico
            </th>

            <th
              scope="col"
              data-column="categoriaCompra.id"
              onClick={(event) => handleSort(event)}
            >
              Categoria
            </th>

            <th
              scope="col"
              data-column="fechaOrden"
              onClick={(event) => handleSort(event)}
            >
              Fecha(Fecha Orden)
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={13} rowCount={4} />}

          {!isLoading &&
            items?.length > 0 &&
            items?.map((item) => {
              const costo = Singleton.getInstance().format(item.costo);
              const precioPublico = Singleton.getInstance().format(
                item.precioPublico,
              );
              const totalPrecioPublico = Singleton.getInstance().format(
                item.totalPrecioPublico,
              );
              const totalPrecioCosto = Singleton.getInstance().format(
                item.totalPrecioCosto,
              );
              const fechaOrden = format(item.fechaOrden, "dd/MM/yy");
              return (
                <tr key={item.id}>
                  <th
                    scope="row"
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.id ?? ""}
                    </a>
                  </th>
                  {/**  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.sku ?? ""}
                    </a>
                  </td>
                   */}
                  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.proveedor.nombre ?? ""}
                    </a>
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    {item.cantidad ?? ""}
                  </td>
                  <td>{item.nombre ?? ""}</td>
                  <td>{item.marca.nombre ?? ""}</td>
                  <td>{item.genero.nombre ?? ""}</td>
                  <td>{costo ?? ""}</td>
                  <td>{totalPrecioCosto ?? ""}</td>
                  <td
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    {item.margen ?? ""}
                  </td>
                  <td>{precioPublico ?? ""}</td>
                  <td>{totalPrecioPublico ?? ""}</td>

                  <td
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <span className={`badge ${handleStatus(item).class}`}>
                      {item.categoriaCompra.nombre}
                    </span>
                  </td>

                  <td
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    {fechaOrden ?? ""}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
